import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";

const BASE = "https://qnexus.in/community/";
// const BASE = "http://localhost/business_community/";

const EditPost = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const post = state?.post;

    const [content, setContent] = useState(post?.content || "");

    if (!post) return <div className="editpost-missing">Post data missing</div>;

    const handleUpdate = async () => {
        if (!content.trim()) return Handler({ message: "Content cannot be empty" });

        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "post",
                url: "/post/update.php",
                data: { post_id: post.id, content: content.trim() }
            });

            if (res?.success) {
                Handler({ success: true, message: "Post updated successfully" });
                navigate(-1);
            }
        } catch (e) { Handler(e); }
        dispatch(loadingFalse());
    };

    return (
        <div className="editpost-page">
            <div className="editpost-card">

                {/* HEADER */}
                <div className="editpost-header">
                    <div className="editpost-user">
                        <img src={BASE + post.logo} className="editpost-avatar" alt="" />
                        <div>
                            <div className="editpost-name">{post.business_name}</div>
                            <div className="editpost-role">Edit your post</div>
                        </div>
                    </div>

                    {/* ✅ ADDED BACK BUTTON */}
                    <div style={{ display: "flex", gap: "10px" }}>
                        <button 
                            onClick={() => navigate(-1)}
                            style={{
                                background: "#f1f5f9",
                                border: "1px solid #e2e8f0",
                                padding: "8px 16px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontWeight: 500,
                                color: "#475569",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                            }}
                        >
                            <i className="bx bx-arrow-back"></i> Back
                        </button>
                        <button className="editpost-share-btn" onClick={handleUpdate}>
                            Update Post
                        </button>
                    </div>

                </div>
                <textarea
                    ref={(el) => {
                        if (el) {
                            el.style.height = "auto";
                            el.style.height = el.scrollHeight + "px";
                        }
                    }}
                    className="editpost-textarea"
                    placeholder="What do you want to talk about?"
                    value={content}
                    rows={1}
                    onChange={(e) => {
                        setContent(e.target.value);
                        e.target.style.height = "auto";
                        e.target.style.height = e.target.scrollHeight + "px";
                    }}
                />


                {/* MEDIA PREVIEW */}
                {post.media?.length > 0 && (
                    <div className="editpost-media-preview">
                        {post && post?.media?.map((m, i) => {
                            if (m.type?.toUpperCase() === "IMAGE") {
                                return <img key={i} src={BASE + m.url} alt="" />;
                            }
                            if (m.type?.toUpperCase() === "VIDEO") {
                                return <video key={i} src={BASE + m.url} controls />;
                            }
                            return null;
                        })}
                    </div>
                )}

                <div className="editpost-note">
                    Media cannot be edited after a post is published. To change the media, please delete this post and create a new one.
                </div>

            </div>
        </div>
    );
};

export default EditPost;